(function () {
  'use strict';
  let config, pending, currentCart, catalogPromise, renderVersion = 0, addingRecommendation = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('en-CA', {style:'currency', currency:config?.currency || 'CAD'}).format(cents / 100);
  function getConfig() {
    if (!config) {
      const node = document.getElementById('xr-rewards-config');
      if (node) config = JSON.parse(node.textContent);
    }
    return config;
  }
  async function request(endpoint, body) {
    const response = await fetch(root() + endpoint, {
      method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
      headers:body ? {'Content-Type':'application/json', 'Accept':'application/json'} : {'Accept':'application/json'},
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Your cart could not be updated.');
    return data;
  }
  // Matches the checkout Function: gifts never count toward spend thresholds.
  function merchandiseSubtotal(cart) {
    return cart.items.reduce((total, item) => total + (item.properties?._xr_gift ? 0 : item.original_line_price), 0);
  }
  function eligibility(cart) {
    const amount = merchandiseSubtotal(cart);
    const paidItems = cart.items.filter(item => !item.properties?._xr_gift);
    return {
      bench:amount >= config.tiers[0], mirror:amount >= config.tiers[1],
      lat:paidItems.some(item => config.rackGifts.lat.includes(item.variant_id)),
      mega:paidItems.some(item => config.rackGifts.mega.includes(item.variant_id))
    };
  }
  function nextReward(amount) {
    if (amount < config.deliveryThreshold) return {amount:config.deliveryThreshold, label:'FREE delivery', short:'free delivery', stage:0};
    if (amount < config.tiers[0]) return {amount:config.tiers[0], label:'a FREE 04 Bench', short:'a free bench', stage:1};
    if (amount < config.tiers[1]) return {amount:config.tiers[1], label:'a FREE MR1000 Mirror', short:'a free mirror', stage:2};
    return null;
  }
  function emphasizeBenefits(node,text) {
    // Build DOM nodes from text, rather than interpolating product data as HTML.
    const parts = text.split(/(\$[\d,]+(?:\.\d{2})?|FREE(?:\s+Canada)?\s+delivery|FREE\s+(?:04 Bench|Model 04 bench|MR1000 Mirror)|04 Bench|MR1000 Mirror|all your complimentary gifts|unlocked)/gi);
    const fragment = document.createDocumentFragment();
    parts.forEach((part,index) => {
      if (index % 2) {
        const strong = document.createElement('strong');
        strong.className = 'xr-cart-emphasis'; strong.textContent = part; fragment.append(strong);
      } else fragment.append(document.createTextNode(part));
    });
    node.replaceChildren(fragment);
  }
  function render(cart) {
    getConfig();
    if (!config || !cart) return;
    const amount = merchandiseSubtotal(cart), next = nextReward(amount);
    const stage = next ? next.stage : 3;
    const bench = config.gifts.bench, mirror = config.gifts.mirror;
    let heading, message;
    if (stage === 0) {
      heading = 'Your next reward';
      message = 'Add ' + money(config.deliveryThreshold - amount) + ' for FREE Canada delivery. Your FREE 04 Bench (worth ' + money(bench.price) + ') unlocks at ' + money(config.tiers[0]) + '.';
    } else if (stage === 1) {
      heading = 'FREE delivery unlocked';
      message = 'You have FREE Canada delivery. Add ' + money(config.tiers[0] - amount) + ' for a FREE 04 Bench worth ' + money(bench.price) + '.';
    } else if (stage === 2) {
      heading = 'Bench + delivery unlocked';
      message = 'FREE delivery and your 04 Bench are unlocked. Add ' + money(config.tiers[1] - amount) + ' for a FREE MR1000 Mirror worth ' + money(mirror.price) + ' too.';
    } else {
      heading = 'All rewards unlocked';
      message = 'You qualify for FREE delivery, the FREE 04 Bench and the FREE MR1000 Mirror. Order now to receive all your complimentary gifts.';
    }
    document.querySelectorAll('[data-xr-rewards]').forEach(panel => {
      panel.dataset.stage = stage;
      panel.querySelector('[data-xr-rewards-stage]').textContent = heading;
      emphasizeBenefits(panel.querySelector('[data-xr-rewards-message]'),message);
      const track = panel.querySelector('[data-xr-rewards-track]');
      track.setAttribute('aria-valuenow', Math.min(amount / 100, config.tiers[1] / 100));
      track.setAttribute('aria-valuetext', message);
      panel.querySelector('[data-xr-rewards-fill]').style.width = Math.min(amount / config.tiers[1] * 100, 100) + '%';
      ['delivery','bench','mirror'].forEach((kind,index) => {
        const milestone = panel.querySelector('[data-xr-milestone="' + kind + '"]');
        milestone?.classList.toggle('is-unlocked', amount >= [config.deliveryThreshold,...config.tiers][index]);
      });
      ['bench','mirror'].forEach((kind,index) => {
        const item = panel.querySelector('[data-xr-reward="' + kind + '"]');
        const unlocked = amount >= config.tiers[index];
        item.classList.toggle('is-unlocked',unlocked);
        item.querySelector('[data-xr-reward-label]').textContent = unlocked ? '✓ FREE — unlocked' : 'At ' + money(config.tiers[index]);
      });
    });
    const count = cart.items.reduce((sum,item) => sum + (item.properties?._xr_gift ? 0 : item.quantity),0);
    document.querySelectorAll('[data-xr-cart-bubble]').forEach(bubble => {
      const text = !count ? 'Free Delivery' : next ? money(next.amount - amount) + ' to ' + next.short : 'All rewards unlocked';
      bubble.querySelector('[data-xr-bubble-message]').textContent = text;
      bubble.querySelector('[data-xr-bubble-eyebrow]').textContent = !count ? 'CANADA-WIDE · ' + money(config.deliveryThreshold) + '+' : 'YOUR CART · ' + count + (count === 1 ? ' ITEM' : ' ITEMS');
      bubble.querySelector('[data-xr-bubble-count]').textContent = count;
      bubble.setAttribute('aria-label','Open cart — ' + text);
      bubble.dataset.stage = stage;
    });
    renderRecommendations(cart, ++renderVersion);
  }
  async function getCatalog() {
    if (!catalogPromise) catalogPromise = request('?sections=xr-cart-recommendations').then(data => {
      const html = data['xr-cart-recommendations'];
      if (!html) throw new Error('Recommendations are temporarily unavailable.');
      const doc = new DOMParser().parseFromString(html,'text/html');
      const node = doc.querySelector('[data-xr-recommendation-catalog]');
      if (!node) throw new Error('Recommendations are temporarily unavailable.');
      return JSON.parse(node.textContent);
    }).catch(error => {catalogPromise = null; throw error;});
    return catalogPromise;
  }
  function rankRecommendations(catalog,cart,next) {
    const paid = cart.items.filter(item => !item.properties?._xr_gift);
    const inCart = new Set(cart.items.map(item => item.product_id));
    const cartProducts = catalog.filter(product => paid.some(item => item.product_id === product.id));
    const gap = next ? next.amount - merchandiseSubtotal(cart) : 0;
    const candidates = catalog.filter(product => !inCart.has(product.id) && product.variants.length).map(product => {
      const sorted = product.variants.slice().sort((a,b) => a.price - b.price);
      const variant = next ? sorted.find(v => v.price >= gap) || sorted[sorted.length - 1] : sorted[0];
      const relevance = cartProducts.reduce((score,current) => score + (current.type && current.type === product.type ? 3 : 0) + (current.vendor === product.vendor ? 1 : 0),0);
      return {product,variant,relevance,sufficient:variant.price >= gap};
    });
    candidates.sort((a,b) => next ? Number(b.sufficient) - Number(a.sufficient) || (a.sufficient ? a.variant.price - b.variant.price : b.variant.price - a.variant.price) || b.relevance - a.relevance || a.product.id - b.product.id : b.relevance - a.relevance || a.variant.price - b.variant.price || a.product.id - b.product.id);
    return candidates.slice(0,4);
  }
  function element(tag,className,text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  async function renderRecommendations(cart,version) {
    const panels = Array.from(document.querySelectorAll('[data-xr-recommendations]'));
    if (!panels.length) return;
    try {
      const catalog = await getCatalog();
      if (version !== renderVersion) return;
      const next = nextReward(merchandiseSubtotal(cart));
      const gap = next ? next.amount - merchandiseSubtotal(cart) : 0;
      const recommendations = rankRecommendations(catalog,cart,next);
      panels.forEach(panel => {
        panel.hidden = !recommendations.length;
        panel.querySelector('[data-xr-recommendation-title]').textContent = next ? 'Reach your next reward' : 'You may also like';
        panel.querySelector('[data-xr-recommendation-eyebrow]').textContent = next ? 'MAKE YOUR ORDER GO FURTHER' : 'MORE FOR YOUR TRAINING';
        emphasizeBenefits(panel.querySelector('[data-xr-recommendation-intro]'),next ? 'Add ' + money(gap) + ' for ' + next.label + '. Items that reach this reward with the least extra spend appear first.' : 'Your FREE delivery, FREE 04 Bench and FREE MR1000 Mirror are unlocked. Explore more equipment for your setup.');
        const list = panel.querySelector('[data-xr-recommendation-list]');
        list.replaceChildren();
        recommendations.forEach(({product,variant,sufficient}) => {
          const card = element('article','xr-reward-suggestion');
          const imageLink = element('a','xr-reward-suggestion__image'); imageLink.href = product.url;
          const image = element('img'); image.src = product.image; image.alt = product.title; image.width = 76; image.height = 76; image.loading = 'lazy'; imageLink.append(image);
          const content = element('div','xr-reward-suggestion__content');
          const title = element('a','xr-reward-suggestion__title',product.title); title.href = product.url; content.append(title);
          if (variant.title !== 'Default Title') content.append(element('small','xr-reward-suggestion__variant',variant.title));
          const preorder = product.tags.some(tag => tag.toLowerCase() === 'preorder');
          const purchase = element('div','xr-reward-suggestion__purchase');
          purchase.append(element('strong','',money(variant.price)));
          const add = element('button','xr-reward-suggestion__add','Add +'); add.type = 'button'; add.dataset.xrRecommendationAdd = variant.id; add.dataset.preorder = preorder ? 'true' : 'false'; add.disabled = addingRecommendation;
          add.setAttribute('aria-label','Add ' + product.title + (variant.title !== 'Default Title' ? ' — ' + variant.title : '') + ' to cart'); purchase.append(add); content.append(purchase);
          if (preorder) content.append(element('small','xr-reward-suggestion__variant','Preorder · timing confirmed separately'));
          if (next) content.append(element('small','xr-reward-suggestion__reward',sufficient ? '✓ Unlocks ' + next.label : money(gap - variant.price) + ' still to go after adding'));
          card.append(imageLink,content); list.append(card);
        });
      });
    } catch (error) {
      panels.forEach(panel => { panel.hidden = true; });
    }
  }
  async function reconcile() {
    getConfig();
    let cart = await request('cart.js');
    if (!config?.enabled || cart.currency !== config.currency) {
      currentCart = cart; render(cart); return cart;
    }
    const wanted = eligibility(cart), updates = {}, existing = new Set();
    for (const item of cart.items) {
      const kind = item.properties?._xr_gift;
      if (!kind) continue;
      const gift = config.gifts[kind];
      if (!gift || !wanted[kind] || !gift.available || item.variant_id !== gift.id || existing.has(kind)) updates[item.key] = 0;
      else {existing.add(kind); if (item.quantity !== 1) updates[item.key] = 1;}
    }
    if (Object.keys(updates).length) cart = await request('cart/update.js',{updates});
    const additions = Object.entries(wanted).filter(([kind,eligible]) => eligible && config.gifts[kind]?.available && !existing.has(kind)).map(([kind]) => ({
      id:config.gifts[kind].id, quantity:1, properties:{_xr_gift:kind, _xr_gift_order:'yes', 'Included gift':config.gifts[kind].title}
    }));
    if (additions.length) {await request('cart/add.js',{items:additions}); cart = await request('cart.js');}
    const chargedGifts = cart.items.filter(item => item.properties?._xr_gift && item.final_line_price !== 0);
    if (chargedGifts.length) {
      await request('cart/update.js',{updates:Object.fromEntries(chargedGifts.map(item => [item.key,0]))});
      throw new Error('Your complimentary gifts could not be applied. Please refresh your cart or contact us before checking out.');
    }
    currentCart = cart; render(cart); return cart;
  }
  function sync() {
    if (pending) return pending;
    pending = reconcile().finally(() => {pending = null;});
    return pending;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-xr-recommendation-add]');
    if (!button || addingRecommendation) return;
    event.preventDefault();
    addingRecommendation = true;
    document.querySelectorAll('[data-xr-recommendation-add]').forEach(node => {node.disabled = true;});
    const status = button.closest('[data-xr-recommendations]').querySelector('[data-xr-recommendation-status]');
    status.textContent = 'Adding to your cart…';
    try {
      await request('cart/add.js',{items:[{id:Number(button.dataset.xrRecommendationAdd),quantity:1,...(button.dataset.preorder === 'true' ? {properties:{'Order type':'Preorder'}} : {})}]});
      await sync();
      document.dispatchEvent(new CustomEvent('cart:build'));
      status.textContent = 'Added. Your rewards have been updated.';
    } catch (error) {status.textContent = error.message;}
    finally {addingRecommendation = false; document.querySelectorAll('[data-xr-recommendation-add]').forEach(node => {node.disabled = false;});}
  });
  window.xrRewards = {sync,render,merchandiseSubtotal};
  document.addEventListener('cart:rendered',() => render(currentCart));
  document.addEventListener('shopify:section:load',() => render(currentCart));
  // Back/forward cache can restore an older cart; reconcile it on return.
  window.addEventListener('pageshow',event => {if (event.persisted) document.dispatchEvent(new CustomEvent('cart:build'));});
})();
